<div class="table-container p-2">
  <table class="table-custom border border-solid border-[#E0E0E0]" mat-table multiTemplateDataRows
    [dataSource]="shareholders">
    <ng-container *ngIf="type === 'OfficerIndirectCompanyType'">
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef class="!w-20 !font-semibold">
          Type
        </th>
        <td mat-cell *matCellDef="let element" class="!w-20">
          <mat-icon [matTooltip]="'Corporate'">apartment</mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold">
          Name
        </th>
        <td mat-cell *matCellDef="let element">
          <p class="line-clamp-3 !mb-0">
            {{ element.officer.name }}
          </p>
        </td>
      </ng-container>

      <ng-container matColumnDef="layer">
        <th mat-header-cell *matHeaderCellDef class="!text-center !font-semibold" [style.z-index]="'101'">
          Shareholder<br /> Layer
          <app-tooltip [minWidth]="320">
            <p class="text-left !mb-0 min-w-[320px]">
              Layer 1 = Direct shareholders<br />
              Layer 2 = Shareholders of the layer 1 shareholders<br />
              Layer 3 = Shareholders of the layer 2 shareholders</p>
          </app-tooltip>
        </th>
        <td mat-cell *matCellDef="let element">
          <p class="line-clamp-3 !mb-0 !text-center">
            {{ element.layer }}
          </p>
        </td>
      </ng-container>

      <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef class="!text-center !font-semibold">
          Incorporation Country
        </th>
        <td mat-cell *matCellDef="let element" class="!text-center">
          <app-country-flag [id]="element.officer.officerProfile.country.id" showCountryName></app-country-flag>
        </td>
      </ng-container>

      <ng-container matColumnDef="percentageOfShares">
        <th mat-header-cell *matHeaderCellDef class="!text-center !font-semibold">
          Ownership
        </th>
        <td mat-cell *matCellDef="let element" class="!text-center">
          {{element.ownership | percentFixed}}
        </td>
      </ng-container>

      <ng-container matColumnDef="documentsStatus">
        <th mat-header-cell *matHeaderCellDef class="!text-center !font-semibold">
          KYC Status
        </th>
        <td mat-cell *matCellDef="let element" class="!text-center">
          <ng-template *ngTemplateOutlet="kycStatusTemplate; context: {element}"></ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="!text-center !font-semibold">
          Actions
        </th>
        <td mat-cell *matCellDef="let element" class="text-center">
          <ng-template *ngTemplateOutlet="baseActions; context: {element}"></ng-template>
        </td>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="type === 'OfficerIndirectPersonType'">
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef class="!w-20 !font-semibold">
          Type
        </th>
        <td mat-cell *matCellDef="let element" class="!w-20">
          <div class="relative">
            <ng-container *ngIf="element.isUBO; else notUBO">
              <mat-icon [matTooltip]="'Individual'" class="custom-icon-gray" svgIcon="person-UBO"></mat-icon>
            </ng-container>

            <ng-template #notUBO>
              <mat-icon [matTooltip]="'Individual'">person</mat-icon>
            </ng-template>

            <!-- <div *ngIf="element.isUBO">
              <span class="absolute bg-[#E6F9F0] text-green-default py-1 px-2 rounded-lg
                             -bottom-3 -left-[.6rem]
                             text-[1rem] font-['OpenSans_Semibold'] !font-semibold">UBO</span>
            </div> -->
          </div>
        </td>
      </ng-container>


      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold">
          Name
        </th>
        <td mat-cell *matCellDef="let element">
          <p class="line-clamp-3 !mb-0">
            {{ element.officer.name }}
          </p>
        </td>
      </ng-container>

      <ng-container matColumnDef="layer">
        <th mat-header-cell *matHeaderCellDef [style.z-index]="'101'" class="!text-center !z[101]">
          Shareholder <br /> Layer
          <app-tooltip [minWidth]="320">
            <p class="text-left !mb-0 min-w-[320px]">Layer 1 = Direct shareholders<br />
              Layer 2 = Shareholders of the layer 1 shareholders<br />
              Layer 3 = Shareholders of the layer 2 shareholders</p>
          </app-tooltip>
        </th>
        <td mat-cell *matCellDef="let element">
          <p class="line-clamp-3 !mb-0 !text-center">
            {{ element.layer }}
          </p>
        </td>
      </ng-container>

      <ng-container matColumnDef="percentageOfShares">
        <th mat-header-cell *matHeaderCellDef class="!text-center !font-semibold">
          Ownership
        </th>
        <td mat-cell *matCellDef="let element" class="!text-center">
          {{ element.ownership | percentFixed}}
        </td>
      </ng-container>

      <ng-container matColumnDef="documentsStatus">
        <th mat-header-cell *matHeaderCellDef class="!text-center !font-semibold">
          KYC Status
        </th>
        <td mat-cell *matCellDef="let element" class="!text-center">
          <ng-template *ngTemplateOutlet="kycStatusTemplate; context: {element}"></ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="residence">
        <th mat-header-cell *matHeaderCellDef class="!text-center !font-semibold">
          Residence
        </th>
        <td mat-cell *matCellDef="let element" class="!text-center">
          <app-country-flag [id]="element.officer.officerProfile.country.id" showCountryName></app-country-flag>
        </td>
      </ng-container>

      <ng-container matColumnDef="nationality">
        <th mat-header-cell *matHeaderCellDef class="!text-center !font-semibold">
          Nationality
        </th>
        <td mat-cell *matCellDef="let element" class="!text-center">
          <app-country-flag [id]="element.officer.officerProfile.nationality.id" showCountryName></app-country-flag>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="!text-center !font-semibold">
          Actions
        </th>
        <td mat-cell *matCellDef="let element" class="!text-center">
          <div class="flex flex-row w-full justify-center">
            <ng-template *ngTemplateOutlet="baseActions; context: {element}"></ng-template>
          </div>
        </td>
      </ng-container>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'add-indirect':row.canViewShareholders}"
      [attr.data-shareholder-id]="row.id">
    </tr>

    <tr class="mat-row" *matNoDataRow>
      <td [colSpan]="3">
        <table-no-record></table-no-record>
      </td>
    </tr>
  </table>
</div>

<ng-template #baseActions let-element="element">
  <button mat-icon-button color="primary" matTooltip="Details of shareholders" (click)="select(element)"
    *ngIf="element.isRequiredKyc && type === 'OfficerIndirectCompanyType'">
    <mat-icon class="cursor-pointer">playlist_add</mat-icon>
  </button>

  <button *ngIf="element?.canUpdate" mat-icon-button matTooltip="Check KYC" color="primary" (click)="checkKyc(element)"
    [disabled]="element.isWaitingForApprovalDeletion">
    <mat-icon class="cursor-pointer">edit</mat-icon>
  </button>

  <button appConfirmDialog (ok)="delete(element)" *ngIf="element?.canDelete" color="warn" mat-icon-button
    [matTooltip]="!element.isWaitingForApprovalDeletion ? 'Delete' : 'Delete request is under review'"
    [disabled]="element.isWaitingForApprovalDeletion">
    <mat-icon svgIcon="bin" class="custom-icon-blue"
      [ngClass]="{'disabled': element.isWaitingForApprovalDeletion}"></mat-icon>
  </button>
</ng-template>

<ng-template #kycStatusTemplate let-element="element">
  <!-- <app-status class="inline-flex" *ngIf="element.documentsStatus && element.isRequiredKyc; else noActionsRequired"
    [statusMessage]="element.documentStatusLabel" [statusStyle]="element.documentsStatusStyle"></app-status>
  <ng-template #noActionsRequired>-</ng-template> -->
  <app-status *ngIf="element.documentStatusLabel && element.isRequiredKyc; else noActionsRequired"
    [statusMessage]="element.documentStatusLabel"
    [statusStyle]="element.documentsStatusStyle === 'warn' ? 'awaiting' : element.documentsStatusStyle"></app-status>
  <ng-template #noActionsRequired>-</ng-template>
</ng-template>